import React, { useState } from "react";
import "./Trendy.css";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../Features/Cart/cartSlice";
import { Link } from "react-router-dom";
import StoreData from "../../../Data/StoreData";
import { FiHeart } from "react-icons/fi";
import { FaStar, FaCartPlus } from "react-icons/fa";
import toast from "react-hot-toast";
import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import Spinner from "../../Spinner";

const Trendy = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("tab1");
  const [wishList, setWishList] = useState({});
  const [products, setProducts] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [spinner, setSpinner] = React.useState(false);

  const getAllProducts = (offset, limit) => {
    setSpinner(true);
    axios({
      method: "POST",
      url: `${backendModule.backendURL}/products/getAllProducts`,
      data: {
        filters: [],
        offset: 0,
        limit: 8
      },
      ...backendModule.axiosConfig,
    }).then(res => {
      if (res.data.status === "ok") {
        setProducts(res.data?.data);
      } else {
        setError('Došlo je do serverske greške');
      }
    }).catch(() => {
      setError('Došlo je do serverske greške');
    }).finally(() => {
      setSpinner(false);
    });
  }

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleWishlistClick = (productID) => {
    setWishList((prevWishlist) => ({
      ...prevWishlist,
      [productID]: !prevWishlist[productID],
    }));
  };

  const sortByPrice = (a, b) => a.productPrice - b.productPrice;

  const sortByReviews = (a, b) => {
    const reviewsA = parseInt(
      a.productReviews.replace("k+ reviews", "").replace(",", "")
    );
    const reviewsB = parseInt(
      b.productReviews.replace("k+ reviews", "").replace(",", "")
    );
    return reviewsB - reviewsA;
  };

  const cartItems = useSelector((state) => state.cart.items);

  const handleAddToCart = (product) => {
    const productInCart = cartItems.find(
      (item) => item.productID === product.productID
    );

    if (productInCart && productInCart.quantity >= 20) {
      toast.error("Product limit reached", {
        duration: 2000,
        style: {
          backgroundColor: "#ff4b4b",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#ff4b4b",
        },
      });
    } else {
      dispatch(addToCart(product));
      toast.success(`Added to cart!`, {
        duration: 2000,
        style: {
          backgroundColor: "#07bc0c",
          color: "white",
        },
        iconTheme: {
          primary: "#fff",
          secondary: "#07bc0c",
        },
      });
    }
  };

  React.useEffect(() => {
    getAllProducts();
  }, []);

  return (
    <>
      <div className="trendyProducts">
        <h2>
          NEKI OD NAŠIH <span>MODELA</span>
        </h2>
        <div className="trendyTabs">
          <div className="trendyTabContent">
            {/* Tab 1 */}
            {activeTab === "tab1" && (
              <div className="trendyMainContainer">
                {products?.map((product) => (
                  <div className="trendyProductContainer" key={product.ID}>
                    <div className="trendyProductImages">
                      <Link to={`/Product?id=${product.ID}`} onClick={scrollToTop}>
                        <img
                          src={`${backendModule.backendURL}/${product.ImagePath}`}
                          alt=""
                          className="trendyProduct_front"
                        />
                        <img
                          src={`${backendModule.backendURL}/${product.ImagePath2}`}
                          alt=""
                          className="trendyProduct_back"
                        />
                      </Link>
                    </div>
                    <div
                      className="trendyProductImagesCart"
                      onClick={() => handleAddToCart(product)}
                    >
                      <FaCartPlus />
                    </div>
                    <div className="trendyProductInfo">
                      <div className="trendyProductCategoryWishlist">
                        <p>{product?.Category}</p>
                      </div>
                      <div className="trendyProductNameInfo">
                        <Link to={`/Product?id=${product.ID}`} onClick={scrollToTop}>
                          <h5>{product.Name}</h5>
                        </Link>

                        <p>{product.Price} KM</p>
                        <div className="trendyProductRatingReviews">
                          <div className="trendyProductRatingStar">
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                            <FaStar color="#FEC78A" size={10} />
                          </div>
                          <span>100+ ocjena</span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="discoverMore">
          <Link to="/shop" onClick={scrollToTop}>
            <p>Pogledaj više modela</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Trendy;
